module.exports = __webpack_public_path__ + "img/levelup_avatar_default.f1ad6334.svg";